import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome styles
import './loadingspinner.css'; // Import your CSS

const loadingspinner = () => {
    return (
        <div className="loading-spinner">
            <div className="spinner">
                <i className="fas fa-rocket spice-icon"></i>               {/* Startup (Rocket) */}
              
             
                <i className="fas fa-code spice-icon"></i>                {/* Web Development (Code) */}
       
                <span className="spice-icon" style={{ fontSize: '32px', color: '#FF6500' }}>₹</span> {/* Rupee Symbol */}
            </div>
        </div>
    );
};

export default loadingspinner;
